var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerIn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0497 12.2548C12.5472 12.2548 12.9726 12.0776 13.3257 11.7233C13.6791 11.3689 13.8558 10.943 13.8558 10.4455C13.8558 9.94803 13.6786 9.52261 13.3242 9.16928C12.9699 8.81611 12.5439 8.63953 12.0462 8.63953C11.5487 8.63953 11.1234 8.81669 10.7703 9.17103C10.4169 9.52536 10.2403 9.95136 10.2403 10.449C10.2403 10.9465 10.4174 11.3719 10.7718 11.725C11.1261 12.0782 11.5521 12.2548 12.0497 12.2548ZM12.048 21.899C9.53133 19.7184 7.64417 17.6889 6.3865 15.8108C5.12883 13.9324 4.5 12.208 4.5 10.6375C4.5 8.32986 5.24642 6.46161 6.73925 5.03278C8.23225 3.60394 10.0018 2.88953 12.048 2.88953C14.0942 2.88953 15.8637 3.60394 17.3567 5.03278C18.8496 6.46161 19.596 8.32986 19.596 10.6375C19.596 12.208 18.9672 13.9324 17.7095 15.8108C16.4518 17.6889 14.5647 19.7184 12.048 21.899Z",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerIn);
export default __webpack_public_path__ + "static/media/marker_in.1db773578255b057ec022549880092a6.svg";
export { ForwardRef as ReactComponent };